import { useCallback } from "react";

import type { Plan } from "@/lib/gql/__generated__/graphql";

import type { DnDResultItem } from "@/hooks/use-dnd";
import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { updatePlanListMutation } from "./mutation";

type Props = {
	hotelID: string;
	dndItemList: Array<DnDResultItem<Plan>>;
};

export const useSortPlanList = ({ hotelID, dndItemList }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc: updatePlanList } = useCustomMutation(updatePlanListMutation);

	const onSavePlanListOrder = useCallback(async () => {
		showLoadingScreenCallback();
		const { errors } = await updatePlanList({
			variables: {
				input: {
					hotelID,
					plans: dndItemList.map((result) => result.value.planID),
				},
			},
		}).finally(() => hideLoadingScreenCallback());

		if (!errors) {
			notifyUserEventInfo({
				title: "プランの並び替えを保存しました",
			});
		}
	}, [dndItemList, hideLoadingScreenCallback, hotelID, showLoadingScreenCallback, updatePlanList]);

	return { onSavePlanListOrder };
};
